import {
    APPLICATION_RESET_STATE,
    APPLICATION_RESET_STATE_SUCCESSFUL,
    APPLICATION_RESET_STATE_FAILED,
    APPLICATION_PERSONAL_INFORMATION,
    APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL,
    APPLICATION_PERSONAL_INFORMATION_FAILED,
    APPLICATION_UPDATE_ADDRESS,
    APPLICATION_UPDATE_ADDRESS_SUCCESSFUL,
    APPLICATION_UPDATE_ADDRESS_FAILED,
    APPLICATION_INCOME_INFORMATION,
    APPLICATION_INCOME_INFORMATION_SUCCESSFUL,
    APPLICATION_INCOME_INFORMATION_FAILED,
    APPLICATION_RESIDENCY_INFORMATION,
    APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL,
    APPLICATION_RESIDENCY_INFORMATION_FAILED,
    APPLICATION_REFERENCE_INFORMATION,
    APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL,
    APPLICATION_REFERENCE_INFORMATION_FAILED,
    APPLICATION_ACCESS_CODE,
    APPLICATION_ACCESS_CODE_SUCCESSFUL,
    APPLICATION_ACCESS_CODE_FAILED,
    APPLICATION_VALIDATE_ACCESS_CODE,
    APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL,
    APPLICATION_VALIDATE_ACCESS_CODE_FAILED,
    APPLICATION_START_CO_SIGNER,
    APPLICATION_START_CO_SIGNER_SUCCESSFUL,
    APPLICATION_START_CO_SIGNER_FAILED,
    APPLICATION_INVITE_CO_EMAIL,
    APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL,
    APPLICATION_INVITE_CO_EMAIL_FAILED,
    APPLICATION_INVITE_CO_SMS,
    APPLICATION_INVITE_CO_SMS_SUCCESSFUL,
    APPLICATION_INVITE_CO_SMS_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    
    addressVerification: false,
    error: false,
    loading: false,
    response: false,
  }
  
  const application = (state = initialState, action) => {
    switch (action.type) {
      case APPLICATION_RESET_STATE:
        state = {
          ...state,          
          error: false, 
          addressVerification: false,
          loading: true,
          response: false,          
        }
        break
      case APPLICATION_RESET_STATE_SUCCESSFUL:
        state = {
          ...state,
          error: false, 
          loading: false,
          
        }
        break
      case APPLICATION_RESET_STATE_FAILED:
        state = {
          ...state,
          error: action.payload,         
          loading: false,
        }
        break
      case APPLICATION_PERSONAL_INFORMATION:
        state = {
          ...state,
          error: false,          
          addressVerification: false,          
          response: false,
          loading: true,
        }
        break
      case APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL:
        state = {
          ...state,
          error: false,
          addressVerification: false,          
          loading: false,
          response: action.payload
          
        }
        break
      case APPLICATION_PERSONAL_INFORMATION_FAILED:
        state = {
          ...state,
          error: action.payload,        
          response: false,
          loading: false,
        }
        break
      case APPLICATION_UPDATE_ADDRESS:
        state = {
          ...state,
          error: false,
          addressVerification: false,
          response: false,
          loading: true,
        }
        break
      case APPLICATION_UPDATE_ADDRESS_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          
        }
        break
      case APPLICATION_UPDATE_ADDRESS_FAILED:
        state = {
          ...state,
          error: action.payload,
          loading: false,
        }
        break
      case APPLICATION_INCOME_INFORMATION:
        state = {
          ...state,
          error: false,         
          response: false,
          loading: true,
        }
        break
      case APPLICATION_INCOME_INFORMATION_SUCCESSFUL:
        state = {
          ...state,
          error: false,         
          loading: false,
          response: action.payload,
        }
        break
      case APPLICATION_INCOME_INFORMATION_FAILED:
        state = {
          ...state,
          error: action.payload,        
          response: false,
          loading: false,
        }
        break
        case APPLICATION_RESIDENCY_INFORMATION:
          state = {
            ...state,
            error: false,         
            response: false,
            loading: true,
          }
          break
        case APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL:
          state = {
            ...state,
            error: false,         
            loading: false,
            response: action.payload,
          }
          break
        case APPLICATION_RESIDENCY_INFORMATION_FAILED:
          state = {
            ...state,
            error: action.payload,        
            response: false,
            loading: false,
          }
          break
        case APPLICATION_REFERENCE_INFORMATION:
          state = {
            ...state,
            error: false,         
            response: false,
            loading: true,
          }
          break
        case APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL:
          state = {
            ...state,
            error: false,         
            loading: false,
            response: action.payload,
          }
          break
        case APPLICATION_REFERENCE_INFORMATION_FAILED:
          state = {
            ...state,
            error: action.payload,        
            response: false,
            loading: false,
          }
          break
          case APPLICATION_ACCESS_CODE:
            state = {
              ...state,
              error: false,         
              response: false,
              loading: true,
            }
            break
          case APPLICATION_ACCESS_CODE_SUCCESSFUL:
            state = {
              ...state,
              error: false,         
              loading: false,
              response: action.payload,
            }
            break
          case APPLICATION_ACCESS_CODE_FAILED:
            state = {
              ...state,
              error: action.payload,        
              response: false,
              loading: false,
            }
            break            
          case APPLICATION_VALIDATE_ACCESS_CODE:
            state = {
              ...state,
              error: false,         
              response: false,
              loading: true,
            }
            break
          case APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL:
            state = {
              ...state,
              error: false,         
              loading: false,
              response: action.payload,
            }
            break
          case APPLICATION_VALIDATE_ACCESS_CODE_FAILED:
            state = {
              ...state,
              error: action.payload,        
              response: false,
              loading: false,
            }
            break                       
          case APPLICATION_START_CO_SIGNER:
            state = {
              ...state,
              error: false,         
              response: false,
              loading: true,
            }
            break
          case APPLICATION_START_CO_SIGNER_SUCCESSFUL:
            state = {
              ...state,
              error: false,         
              loading: false,
              response: action.payload,
            }
            break
          case APPLICATION_START_CO_SIGNER_FAILED:
            state = {
              ...state,
              error: action.payload,        
              response: false,
              loading: false,
            }
            break                      
            case APPLICATION_INVITE_CO_EMAIL:
              state = {
                ...state,
                error: false,         
                response: false,
                loading: true,
              }
              break
            case APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL:
              state = {
                ...state,
                error: false,         
                loading: false,
                response: action.payload,
              }
              break
            case APPLICATION_INVITE_CO_EMAIL_FAILED:
              state = {
                ...state,
                error: action.payload,        
                response: false,
                loading: false,
              }
              break                     
              case APPLICATION_INVITE_CO_SMS:
                state = {
                  ...state,
                  error: false,         
                  response: false,
                  loading: true,
                }
                break
              case APPLICATION_INVITE_CO_SMS_SUCCESSFUL:
                state = {
                  ...state,
                  error: false,         
                  loading: false,
                  response: action.payload,
                }
                break
              case APPLICATION_INVITE_CO_SMS_FAILED:
                state = {
                  ...state,
                  error: action.payload,        
                  response: false,
                  loading: false,
                }
                break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default application
  